// extracted by mini-css-extract-plugin
export default {"border":"VerticalBorder_border__IoKW8"};